import classnames from 'classnames'

import { getQaSelector, isValidElementType } from '../../utils/common'
import { IconNG } from '../Icon'
import { Skeleton } from '../Skeleton'

import {
  AVATAR_CLASS_ALIASES,
  AVATAR_HEIGHT_48,
  AVATAR_ICON_SIZE_MAP,
  QA_NAME_AVATAR_DEFAULT,
} from './Avatar.constants'
import { getText } from './Avatar.utils'
import { ColorLayer } from './ColorLayer'

import * as styles from './Avatar.module.css'

function Avatar({
  Icon,
  alt,
  children,
  className,
  color,
  iconProps,
  iconSize,
  imageProps,
  isLoading,
  qaName,
  ref,
  size = AVATAR_HEIGHT_48,
  src,
  text,
}) {
  // A draft persisted to localStorage serializes its recipient avatars, turning
  // the `Icon` component into a plain object that would crash IconNG on restore.
  const IconComponent = isValidElementType(Icon) ? Icon : null

  const avatarClassName = classnames(
    styles.avatar,
    [styles[AVATAR_CLASS_ALIASES[size]]],
    { [styles.background]: !!IconComponent, [styles.skeleton]: isLoading },
    className
  )

  const qaProps = getQaSelector({
    context: QA_NAME_AVATAR_DEFAULT,
    def: QA_NAME_AVATAR_DEFAULT,
    value: qaName,
  })

  return isLoading ? (
    <Skeleton
      className={classnames(
        styles.skeleton,
        styles[AVATAR_CLASS_ALIASES[size]],
        className
      )}
    />
  ) : (
    <div {...qaProps} className={avatarClassName} ref={ref}>
      {!src && !IconComponent && text ? (
        <ColorLayer color={color}>
          <span className={styles.text}>{getText(text)}</span>
        </ColorLayer>
      ) : null}
      {src && (
        <img {...imageProps} alt={alt} className={styles.image} src={src} />
      )}
      {IconComponent && !src ? (
        <IconNG
          {...iconProps}
          Icon={IconComponent}
          size={iconSize || AVATAR_ICON_SIZE_MAP[size]}
        />
      ) : null}
      {children}
    </div>
  )
}

export default Avatar
